import { render } from "./PropEdit.vue?vue&type=template&id=647b9756&scoped=true"
import script from "./PropEdit.vue?vue&type=script&lang=js"
export * from "./PropEdit.vue?vue&type=script&lang=js"

import "./PropEdit.vue?vue&type=style&index=0&id=647b9756&lang=css"
import "./PropEdit.vue?vue&type=style&index=1&id=647b9756&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647b9756"]])

export default __exports__